import useDepositInputStore from 'src/stores/DepositInputStore/useDepositInputStore';
import { useSpotMarkets } from 'src/hooks/spotMarkets/useSpotMarkets';
import { useEffect } from 'react';
export const useSyncDepositInputStore = () => {
	const depositInputStore = useDepositInputStore();
	const spotMarkets = useSpotMarkets();

	useEffect(() => {
		depositInputStore.set((s) => {
			s.selectedSpotMarket = spotMarkets[0];
		});
	}, [spotMarkets]);
};
